import angular from 'angular';
import 'angular-bootstrap';
import 'ui-select';
import locales from '../../locale';
import './rebusesServices';

const rebusesControllers = angular.module('applicationModule.rebusesControllers', ['applicationModule.rebusesServices', 'ui.bootstrap']);

rebusesControllers.controller('RebusesController', ['$scope', '$rootScope', '$stateParams', '$state', 'NgTableParams', 'Rebus', 'growl', 'AppsoupAPI', 'Permissions', '$modal', function ($scope, $rootScope, $stateParams, $state, NgTableParams, Rebus, growl, AppsoupAPI, Permissions, $modal) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('rebuses');
    $scope.app_id = $stateParams.application_id;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Rebus.getList($scope.app_id, params._params).then(function (response) {
                params.total(response.rebuses.total);
                params.count(response.rebuses.per_page);
                params.page(response.rebuses.current_page);
                return response.rebuses.data;
            }).finally(function () {
                $scope.isLoading = false;
            });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.pending = function () {
        var modalInstance = $modal.open({
            templateUrl: 'views/application/rebuses/pending_rebuses.tpl.html',
            controller: 'PendingRebusModalController',
            animation: true,
            backdrop: 'static',
            size: 'lg'
        });
        modalInstance.result.then(function () {
            $state.go($state.current, {}, {reload: true});
        }).catch(() => {});
    };

    $scope.newRebus = function () {
        openModal();
    };

    $scope.editRebus = function (rebusId, index) {
        Rebus.get(rebusId).then(function (result) {
            let data = result.data;

            if (data.success) {
                openModal(data.rebus, index);
            } else {
                growl.error('MODULES.REBUSES.' + data.error);
            }
        });
    };

    function openModal(rebus, index) {
        var modalInstance = $modal.open({
            templateUrl: 'views/application/rebuses/rebus.tpl.html',
            controller: 'RebusModalController',
            animation: true,
            resolve: {
                rebus: function () {
                    return rebus;
                }
            }
        });
        modalInstance.result.then(function (rebus) {
            if (angular.isDefined(index)) {
                $scope.tableParams.data[index] = rebus;
            } else {
                $scope.tableParams.data.push(rebus);
            }
        }).catch(() => {});
    }

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.removeRebus = function (id, index) {
        Rebus.remove(id, $scope.app_id).then(function (result) {
            let data = result.data;

            if (data.success) {
                growl.success('MODULES.REBUSES.SUCCESS.DELETED');
                $scope.tableParams.data.splice(index, 1);
            } else {
                growl.error('MODULES.REBUSES.ERROR.DELETED');
            }
        });
    };
}]);

rebusesControllers.controller('RebusModalController', ['$scope', '$rootScope', '$stateParams', '$state', 'Rebus', 'rebus', 'growl', 'Permissions', '$modalInstance', function ($scope, $rootScope, $stateParams, $state, Rebus, rebus, growl, Permissions, $modalInstance) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('rebuses');
    var app_id = $stateParams.application_id;

    $scope.editMode = false;
    $scope.rebus = {
        app_id: app_id,
        status: true
    };
    $scope.levels = [];

    if (rebus) {
        $scope.rebus = rebus;

        if (rebus.id) {
            $scope.editMode = true;
        }
    }

    $scope.autocomplete = function (text) {
        text = text.toLowerCase().trim();
        text = encodeURIComponent(text);
        Rebus.autocompleteLevels(app_id, text).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.levels = data.levels;
            } else {
                growl.error('MODULES.APPLICATIONS.MODULES.DISHES.GROWL.ERROR.' + data.error);
            }
        });
    };

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.rebusForm.$valid) {
            $scope.isLoading = true;
            if ($scope.rebus.status === 'false') {
                $scope.rebus.status = false;
            }
            Rebus.save($scope.rebus, $scope.editMode).then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.REBUSES.SUCCESS.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                    $modalInstance.close(data.rebus);
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.REBUSES.ERROR.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                    }
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
        }
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.inputErrors = {
        'image': [{type: '$invalid', msg: 'ERROR.REQUIRED'}],
        'answer': [{type: '$invalid', msg: 'ERROR.REQUIRED'}],
        'author': [{type: '$invalid', msg: 'ERROR.REQUIRED'}],
        'level_id': [{type: '$invalid', msg: 'ERROR.REQUIRED'}]
    };

}]);

rebusesControllers.controller('PendingRebusModalController', ['$scope', '$rootScope', '$stateParams', '$state', 'PendingRebus', 'growl', 'Permissions', '$modal', '$modalInstance', function ($scope, $rootScope, $stateParams, $state, PendingRebus, growl, Permissions, $modal, $modalInstance) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('rebuses');
    var app_id = $stateParams.application_id;

    $scope.isLoading = true;
    $scope.rebuses = {};

    PendingRebus.getList(app_id).then(function (result) {
        let data = result.data;

        $scope.rebuses = data.pending_rebuses;
    }).finally(function () {
        $scope.isLoading = false;
    });

    $scope.addRebus = function (rebus, index) {
        var id = rebus.id;
        delete rebus.id;
        rebus.status = true;
        var modalInstance = $modal.open({
            templateUrl: 'views/application/rebuses/rebus.tpl.html',
            controller: 'RebusModalController',
            animation: true,
            resolve: {
                rebus: function () {
                    return rebus;
                }
            }
        });
        modalInstance.result.then(function () {
            $scope.removeRebus(id, index);
        }).catch(() => {});
    };

    $scope.removeRebus = function (id, index) {
        PendingRebus.remove(id).then(function (result) {
            let data = result.data;

            if (data.success) {
                growl.success('MODULES.REBUSES.SUCCESS.DELETED');
                $scope.rebuses.splice(index, 1);
            } else {
                growl.error('MODULES.REBUSES.ERROR.DELETED');
            }
        }).catch(function () {
            growl.error('MODULES.REBUSES.ERROR.DELETED');
        });
    };

    $scope.close = function () {
        $modalInstance.dismiss('cancel');
    };

}]);

export default rebusesControllers;
